import React from 'react';
import { Plus, Play, BarChart3, Award } from 'lucide-react';

const steps = [
  {
    number: '01',
    icon: <Plus size={20} />,
    title: 'Make a commitment',
    description: "Name what you're going to do. Set how long you'll spend on it. Be honest — not optimistic.",
    screenshot: 'https://customer-assets.emergentagent.com/job_cyber-countdown/artifacts/f2l7wkkb_IMG_8830.PNG'
  },
  {
    number: '02',
    icon: <Play size={20} />,
    title: 'Start the clock',
    description: "Hit start. The countdown begins. There's no pause button. The clock is the commitment.",
    screenshot: 'https://customer-assets.emergentagent.com/job_cyber-countdown/artifacts/s7kqiv1c_IMG_8423.PNG'
  },
  {
    number: '03',
    icon: <BarChart3 size={20} />,
    title: 'Deliver — or face the data',
    description: "When the timer ends, you mark it done or failed. Both outcomes are recorded.",
    screenshot: 'https://customer-assets.emergentagent.com/job_cyber-countdown/artifacts/4rvnf7va_IMG_8746.PNG'
  },
  {
    number: '04',
    icon: <Award size={20} />,
    title: 'Watch the pattern emerge',
    description: "Day by day, your streak grows. Your success rate becomes visible.",
    screenshot: 'https://customer-assets.emergentagent.com/job_cyber-countdown/artifacts/x9dlz4t4_IMG_8424.PNG'
  }
];

const HowItWorks = () => {
  return (
    <section id="how-it-works" className="relative py-32 px-6 lg:px-12" style={{ background: '#08080f' }}>
      <div className="max-w-7xl mx-auto relative z-10">
        {/* Section header */}
        <div className="text-center mb-20 reveal">
          <div className="section-label">The Process</div>
          <h2 className="text-4xl lg:text-6xl font-black tracking-tight mb-5">
            How{' '}
            <span className="gradient-text">TickBoom</span>
            {' '}works
          </h2>
          <p className="text-lg text-[rgba(255,255,255,0.4)] max-w-xl mx-auto">
            Four steps. The method is simple. The discipline is yours to build.
          </p>
        </div>

        {/* Steps grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5 mb-16">
          {steps.map((step, index) => (
            <div key={index} className={`cyber-card p-7 relative reveal delay-${index * 100 + 100}`}>
              {/* Step number */}
              <div className="text-xs font-mono font-bold gradient-text mb-5 tracking-widest">
                {step.number}
              </div>

              {/* Icon */}
              <div className="w-9 h-9 mb-5 flex items-center justify-center rounded-lg bg-[rgba(124,58,237,0.1)] text-[#7C3AED]">
                {step.icon}
              </div>

              {/* Content */}
              <h3 className="text-base font-semibold mb-2 text-white">{step.title}</h3>
              <p className="text-sm text-[rgba(255,255,255,0.4)] leading-relaxed">{step.description}</p>
            </div>
          ))}
        </div>

        {/* App Screenshots */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
          {steps.map((step, index) => (
            <div key={index} className="group">
              <div
                className="relative rounded-2xl overflow-hidden transition-all duration-300 hover:scale-105"
                style={{ border: '1px solid rgba(255,255,255,0.08)' }}
              >
                <img
                  src={step.screenshot}
                  alt={`${step.title} - TickBoom App`}
                  className="w-full h-auto"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3 w-7 h-7 rounded-md flex items-center justify-center font-mono font-bold text-xs text-white bg-[rgba(0,0,0,0.7)] backdrop-blur-sm">
                  {step.number}
                </div>
              </div>
              <p className="text-center mt-2 text-xs text-[rgba(255,255,255,0.3)] font-mono uppercase tracking-wider">
                {step.title}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
